export const ICT_ROUTES = {
  STATS: {
    TICKETS: '/ict/stats/tickets/' as const,
    WORKSTATIONS: '/hardware/workstations/' as const,
    SERVERS: '/hardware/servers/' as const,
    LICENSING: '/ict/stats/licensing/' as const,
  },
  NETWORK: '/ict/network/devices' as const,
  ZEROTRUSTMANAGEMENT: '/ict/vpn/overview' as const,

};
